import { ActionStatus } from "sprint-common-web";

import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { FileRecordListingItem } from "../types/FileRecordListingItem";

export interface RejectFileRecordListingItem {
    id: string;
    filename: string;
    filePath?: string;
    reference?: string;
    originator?: string;
    arrivalDate: string;
    status: FileRecordStatus;
}

export type ProcessRejectFileRecordListingItem = RejectFileRecordListingItem & {
    processStatus: ActionStatus;
};

export const mapToRejectFileRecordListingItem = (fileRecord: FileRecordListingItem): RejectFileRecordListingItem => {
    return {
        id: fileRecord.id,
        arrivalDate: fileRecord.arrivalDate,
        filePath: fileRecord.filePath,
        originator: fileRecord.originator?.name ?? undefined,
        filename: fileRecord.deliveryFileName,
        reference: fileRecord.deliveryRef,
        status: fileRecord.status
    };
};
